import { Breadcrumbs as BreadcrumbsComponent } from '@bridebook/web/app-basic/components/breadcrumbs/breadcrumbs.component';
import { FC, memo } from 'react';
import type { Slug } from '@bridebook/toolbox/src/types';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { ILocationData } from '@bridebook/web/app-shared/lib/search/types';
import { IBreadcrumbItem } from '@bridebook/web/app-shared/lib/types';
import { getBreadcrumbsLocation } from '@bridebook/web/app-shared/lib/utils';

interface BreadcrumbsProps {
  locationData: ILocationData;
  slug: Slug;
}

const BreadcrumbsContainer: FC<BreadcrumbsProps> = ({ locationData, slug }) => {
  const market = useMarket();
  // TODO: [i18n][bb-global]: Check handling in getBreadcrumbsLocation for locale
  const breadcrumbsData = getBreadcrumbsLocation({
    locationData,
    market,
    slug,
  }) as IBreadcrumbItem[];

  return <BreadcrumbsComponent breadcrumbsData={breadcrumbsData} center={false} showAlways />;
};

export const Breadcrumbs = memo(BreadcrumbsContainer);
